import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import searchImg from '../assets/search.svg';
import { addSearchItem } from '../redux/Filter/action';
const Search = () => {
  const dispatch = useDispatch();

  const debounce = (func) => {
    let timer;
    return function (...args) {
      const context = this;
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        timer = null;
        func.apply(context, args);
      }, 1000);
    };
  };
  const handleChange = (e) => {
    e.preventDefault();
    dispatch(addSearchItem(e.target.value));
  };

  const handleDebounce = useCallback(debounce(handleChange), []);
  return (
    <div className="border mt-6 border-slate-200 flex items-center w-11/12 lg:w-1/2 mx-auto bg-gray-50 h-12 px-5 rounded-lg text-sm ring-emerald-200">
      <input
        onChange={handleDebounce}
        className="outline-none border-none bg-gray-50 h-full w-full mr-2"
        type="search"
        name="search"
        placeholder="Search"
      />
      <img className="inline h-6 cursor-pointer" src={searchImg} alt="Search" />
    </div>
  );
};

export default Search;
